import React, { useState, useCallback } from "react";
import { Modal, Typography} from "@ann/web-components";
import { HeaderTitleWrapper, BodyContentWrapper, ActionsWrapper } from "./RemoveConfirmModal.styled";

const RemoveConfirmModal = ({
  isOpen,
  onClose,
  title,
  description,
  confirmLabel,
  onConfirm,
}) => {
  const [isRemoving, setIsRemoving] = useState(false);

  const handleConfirm = useCallback(async () => {
    if (!onConfirm) return;
    setIsRemoving(true);
    try {
      await onConfirm();
    } catch {
    } finally {
      setIsRemoving(false);
    }
  }, [onConfirm]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="large">
      <Modal.Header>
        <HeaderTitleWrapper>
          <Modal.Header.Title>{title}</Modal.Header.Title>
        </HeaderTitleWrapper>
      </Modal.Header>
      <Modal.Body>
        <BodyContentWrapper>
          <Typography category="body" size="medium" weight="regular" color="body">
            {description}
          </Typography>
        </BodyContentWrapper>
      </Modal.Body>
      <Modal.Actions>
        <ActionsWrapper>
          <Modal.Button
            label="Cancel"
            onClick={onClose}
            type="secondary"
            disabled={isRemoving}
          />
          <Modal.Button
            label={isRemoving ? "Removing..." : confirmLabel}
            onClick={handleConfirm}
            type="error"
            disabled={isRemoving}
          />
        </ActionsWrapper>
      </Modal.Actions>
    </Modal>
  );
};

export default RemoveConfirmModal;
